import BenefitsList from "./BenefitsList";
import ActivityList from "./ActivityList";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { sampleActivityData } from "../../../../utils";
import TabSelectButtonGroup from "../../../../../../../common/Buttons/TabSelectButtonGroup";
import {
  getMembershipShortlinkActivity,
  getSubscribedMembershipsRewards,
} from "../../../../../../../../redux/actions/shortlinkActions";

const BenefitActivityList = ({
  currMemb,
  isShortlink,
  handleRenew,
  currencyView,
  isPurchasedInTestStatus,
}) => {
  const dispatch = useDispatch();
  const [activityData, setActivityData] = useState({});
  const [activityDocsList, setActivityDocsList] = useState([]);

  const [tabBtnKey, setTabBtnKey] = useState("benefit"); // benefit, activity
  const [isLoadingRewards, toggleLoadingRewards] = useState(false);
  const [isLoadingActivity, toggleLoadingActivity] = useState(false);

  const initData = useSelector((state) => state?.shortLink?.initData);
  const purchasedMembDets = useSelector(
    (state) => state?.shortLink?.purchasedMembDets
  );

  const customerId =
    initData?.type === "membership"
      ? initData?.customer_id
      : initData?.type === "loyalty"
      ? initData?.customer?.id
      : initData?.type === "qr_code"
      ? currMemb?.customer_id
      : "";

  const entityId =
    initData?.type === "membership"
      ? currMemb?.membership?.entity_id?._id ?? currMemb?.membership?.entity_id
      : initData?.type === "loyalty"
      ? initData?.group?.id || initData?.store?.id
      : initData?.type === "qr_code"
      ? initData?.qr_code?.entity_id?.group ?? initData?.qr_code?.entity_id?.id
      : "";

  const membershipId = currMemb?.membership?._id;
  const finalActivityData = isPurchasedInTestStatus
    ? sampleActivityData
    : activityData;
  const finalActivityDocsList = isPurchasedInTestStatus
    ? sampleActivityData.docs
    : activityDocsList;
  const isShowBeneActivityTabs =
    isShortlink && finalActivityData?.totalDocs > 0;
  let rewards =
    isShortlink && initData?.membership && initData?.type === "membership"
      ? purchasedMembDets?.rewards
      : currMemb?.rewards;

  rewards = rewards?.filter((reward) => reward?.is_active) ?? [];

  if (isPurchasedInTestStatus)
    rewards = rewards?.map((reward) => ({
      ...reward,
      redemption_limit: 1,
      redemptions_till_date: 0,
    }));

  useEffect(() => {
    if (isShortlink) {
      if (initData?.membership && initData?.customer_id?.length > 0)
        fetchMembershipBenefits();
      if (
        currMemb?.subscription_id?.length > 0 ||
        (initData?.membership && initData?.customer_id?.length > 0)
      )
        fetchMembershipActivity();
    }
  }, [isShortlink, entityId, customerId, currMemb?.subscription_id]);

  const fetchMembershipBenefits = () => {
    if (!customerId || !entityId) return;

    const query = {
      entityId,
      customerId,
      membershipId,
    };

    toggleLoadingRewards(true);
    dispatch(getSubscribedMembershipsRewards(query))
      .then(() => toggleLoadingRewards(false))
      .catch(() => toggleLoadingRewards(false));
  };

  const fetchMembershipActivity = (fetchMore) => {
    if (!customerId || !entityId || !currMemb?.membership) return;

    const query = {
      entityId,
      customerId,
      membershipId,
      page: fetchMore ? activityData?.page + 1 : 1,
      isGroupMembership: currMemb?.membership?.entity_type === "Group",
    };

    toggleLoadingActivity(true);
    getMembershipShortlinkActivity(query)
      .then((payload) => {
        setActivityData(payload);
        setActivityDocsList((prev) =>
          fetchMore ? [...prev, ...payload.docs] : payload?.docs
        );
      })
      .finally(() => toggleLoadingActivity(false));
  };

  return (
    <>
      {isShowBeneActivityTabs && (
        <TabSelectButtonGroup
          variant="secondary"
          activeTab={tabBtnKey}
          extraClass="benefit-activity-tabs"
          setActiveTab={(key) => setTabBtnKey(key)}
          tabList={[
            {
              key: "benefit",
              text: "Benefits",
            },
            {
              key: "activity",
              text: "Activity",
            },
          ]}
        />
      )}
      {tabBtnKey === "benefit" ? (
        <BenefitsList
          benefits={rewards}
          currencyView={currencyView}
          isLoadingRewards={isLoadingRewards}
        />
      ) : (
        <ActivityList
          handleRenew={handleRenew}
          currencyView={currencyView}
          currMemb={currMemb?.membership}
          activityData={finalActivityData}
          isLoadingActivity={isLoadingActivity}
          activityDocsList={finalActivityDocsList}
          fetchMembershipActivity={fetchMembershipActivity}
        />
      )}
    </>
  );
};

export default BenefitActivityList;
